import { BASE_URL } from '../common/constants/AppConstants';
import { baseGetAPICall, getAPICall, postAPICall } from './BaseAPI';

export const login = (email: any, password: any, callback: any) => {
  const payload = { email, password };
  postAPICall('login', payload, callback);
};

export const logout = async (callback: any) => {
  return await postAPICall('logout', {}, callback);
};

export const signup = (email: any, password: any, name: any, callback: any) => {
  const payload = { email, password, name };
  postAPICall('signup', payload, callback);
};

export const testTokenValid = async (callback: any) => {
  return await getAPICall('testtokenvalid', callback);
};

export const getAPICommitId = async (callback: any) => {
  return await getAPICall('getapicommitid', callback);
};

export const privateSync = (token: any, callback: any) => {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  baseGetAPICall('private', headers, callback);
};

export const resetPass = (email: any, callback: any) => {
  const payload = {
    email,
    clientHost: BASE_URL,
    accountType: 'staff',
  };
  postAPICall('resetpass', payload, callback);
};

export const newPasword = (recoveryId: any, password: any, callback: any) => {
  const payload = { recoveryId, password };
  postAPICall('newpassword', payload, callback);
};
